// Pays de livraison choisi dans l'app (chantier international, 2026-10-02)
// — sert UNIQUEMENT a afficher un prix dans la bonne devise AVANT qu'une
// adresse existe (page Tarifs, choix du format a la creation du livre).
// Volontairement plus simple que languagePreference.js : pas de
// synchronisation sur le compte (user_metadata), parce que la devise
// REELLEMENT facturee a la commande vient toujours de l'adresse de
// livraison saisie a ce moment-la (voir routes/orders.js, resolveCountry) —
// ce choix precoce n'est qu'une estimation, jamais une donnee a faire
// suivre d'un appareil a l'autre.
const STORAGE_KEY = 'bookipix_country';
const DEFAULT_COUNTRY = 'FR';

// Pays ou l'on livre (meme liste que backend/services/pricing/pricingConfig.js SHIPPING_PRICE_CENTS), dans l'ordre du
// selecteur. Maroc, Tunisie et Algerie retires le 2026-11-02.
export const SUPPORTED_COUNTRIES = ['FR', 'BE', 'CH', 'LU', 'MC', 'DE', 'ES', 'IT', 'NL', 'PT', 'GB', 'CA', 'US'];

// Un pays memorise qui n'est plus livre (ex. « MA » choisi avant son retrait) retombe sur la France.
export function getCountryPreference() {
  try {
    const choisi = localStorage.getItem(STORAGE_KEY);
    return SUPPORTED_COUNTRIES.includes(choisi) ? choisi : DEFAULT_COUNTRY;
  } catch (_error) {
    return DEFAULT_COUNTRY;
  }
}

export function setCountryPreference(country) {
  try {
    localStorage.setItem(STORAGE_KEY, country);
  } catch (_error) {
    // Navigation privee/stockage refuse : jamais bloquant, le choix reste
    // juste local a cette page tant que le stockage est indisponible.
  }
  window.dispatchEvent(new CustomEvent('bookipix:country-changed', { detail: { country } }));
}

// PAYS PROPOSE A L'ARRIVEE (2026-11-02, demande du fondateur) : un visiteur du Canada voit d'emblee les prix en dollars
// canadiens et le port du Canada. Uniquement tant que le visiteur n'a RIEN choisi (cle absente) : un choix fait au selecteur
// n'est jamais ecrase, et le pays detecte une fois devient le choix memorise (pas de nouvelle detection a chaque visite).
// Pays ou l'on ne livre pas (ou detection impossible) : rien ne change, la France reste le defaut.
export async function detectCountryOnFirstVisit(detecter) {
  let dejaChoisi = true;
  try { dejaChoisi = Boolean(localStorage.getItem(STORAGE_KEY)); } catch (_error) { return null; }
  if (dejaChoisi) return null;
  try {
    const pays = await detecter();
    // Le visiteur a pu choisir pendant la detection : son choix gagne.
    if (!pays || localStorage.getItem(STORAGE_KEY)) return null;
    setCountryPreference(pays);
    return pays;
  } catch (_error) {
    return null; // jamais bloquant
  }
}

export { DEFAULT_COUNTRY };
